import { useFormikContext } from "formik";
import React, { FC } from "react";
import { CustomFieldBuilder } from "../../../containers/utilities/CustomFieldBuilder";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    supportedFields?: any[];
    modeName?: string;
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined, supportedFields = undefined, modeName }) => {
    const { translate } = useLocale();
    const formik = useFormikContext();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);

    return <div className="flex flex-col pr-3 h-full relative" style={{ height: "501px" }}>
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.mode)}: <span className="text-sm text-black">{modeName}</span></h4>
            <br />
            <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.outputStates)}</h2>
            {supportedFields
                ? supportedFields.reduce((formFields, field) => customFieldBuilder.buildSummaryField(formFields, field), new Array(0))
                    .map(fieldBundle => <div className="flex flex-row">{fieldBundle.length === 1
                        ? fieldBundle[0].span
                            ? fieldBundle[0].content
                            : <>{fieldBundle[0].content}
                                <div className="flex flex-col flex-1 pl-3"></div></>
                        : fieldBundle.map(field => field.content)}</div>)
                : <span>{translate.byKey(TranslationKeys.noContent)}</span>}
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={e => {
                        if (onBack)
                            onBack(e);
                    }}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type={false ? 'button' : 'submit'}
                    onClick={onNext ? (e) => onNext(e) : () => { }}>{translate.byKey(TranslationKeys.submit)}</button>
            </div>
        </div>
    </div>;
};
